"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketLifecycleInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketLifecycleInput.js.map